// AI-CONTEXT: See docs/features/participatieladder-2026-3.md
import { BENEFIT_TYPE_OPTIONS } from './participationOptions'

/**
 * @typedef {object} ParticipationFormSpec
 * @property {Array<string>} benefitTypeOptions - Keuzes bij 'Ontvang je een uitkering?'
 * @property {boolean} askBenefitShare - Vraag naar het deel van de bijstand (alleen 2026.1/2026.2)
 * @property {boolean} askLoonkostensubsidie - Vraag naar loonkostensubsidie bij werk (2026.3)
 * @property {Array<string>} dagbestedingOptions - Soort dagbesteding; leeg = niet vragen
 * @property {Array<number>} dagdelenOptions - Dagdelen per week bij een gekozen soort
 * @property {Array<string>} educationTargetOptions - Doelniveau bij opleiding; leeg = niet vragen
 */

/**
 * Welke vragen en keuzes het participatieformulier toont. De vragen komen uit
 * de vastgezette parameterset (`options`): 2026.3 kent loonkostensubsidie,
 * dagbesteding en het doelniveau van een opleiding, en geen deel van de
 * bijstand meer (de aanvulling volgt uit uitkering − loon). Zonder `posts`
 * (2026.1/2026.2) of zonder parameters: het formulier van toen.
 *
 * @param {object|null} parameters - De vastgezette parameterset
 * @returns {ParticipationFormSpec}
 */
const getParticipationFormSpec = (parameters) => {
    const isPosts = Array.isArray(parameters?.posts)
    const options = (isPosts && parameters.options) || {}
    return {
        benefitTypeOptions: isPosts ? options.benefitType : BENEFIT_TYPE_OPTIONS,
        askBenefitShare: !isPosts,
        askLoonkostensubsidie: isPosts && Array.isArray(options.loonkostensubsidie),
        dagbestedingOptions: options.dagbesteding || [],
        dagdelenOptions: options.dagdelenPerWeek || [],
        educationTargetOptions: options.educationTarget || [],
    }
}

/**
 * Het uitkeringstype zoals het formulier het toont: onder 2026.3 wordt een oud
 * antwoord omgezet volgens `benefitRules.legacyBenefitType`, zoals de
 * berekening het ook leest. Het opgeslagen antwoord verandert pas als iemand
 * het formulier wijzigt.
 *
 * @param {string|undefined} benefitType
 * @param {object|null} parameters
 * @returns {string}
 */
export const displayBenefitType = (benefitType, parameters) => {
    if (!benefitType) return ''
    const legacy = (Array.isArray(parameters?.posts) && parameters.benefitRules?.legacyBenefitType) || {}
    return legacy[benefitType] || benefitType
}

export default getParticipationFormSpec
